import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { WhyItDidntWork } from './components/WhyItDidntWork';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoThisIsFor } from './components/WhoThisIsFor';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { FAQ } from './components/FAQ';
import { FinalOffer } from './components/FinalOffer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <WhyItDidntWork data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhoThisIsFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <SocialProof data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalOffer data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}